<template>
  <section>

    <!-- SNACKBAR -->
    <v-snackbar
      v-model="snackbar.show"
      :timeout="10000"
      multi-line
      left
      top
      :color="snackbar.color"
    >
      {{ snackbar.text }}
      <v-btn
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>

    <!-- LOADING DIALOG -->

    <v-dialog
      v-model="dialogs.loading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogs.delete"
      max-width="500"
      persistent
      v-if="dialogs.hasLoaded"
    >
      <v-card>
        <v-card-title class="headline">You Sure, about deleting this Entity?</v-card-title>

        <v-card-text>
          Are you sure, you want to delete this entity? <br/> We suggest verifying the details before taking such an action.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="success"
            flat="flat"
            @click="() => {
                $router.push(`/evoting/entity/${$route.params.id}`);
                dialogs.delete = false;
              }"
          >
            Don't Delete
          </v-btn>

          <v-btn
            color="error"
            flat="flat"
            @click="deleteEntity"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogs.update"
      max-width="500"
      persistent
      v-if="dialogs.hasLoaded"
    >
      <v-form v-model="valid">
        <v-card>
          <v-card-title class="headline">Update this Entity!</v-card-title>

          <v-card-text>
              <div>
                <v-text-field label="NAME" v-model="form.name" :rules="nameRules"></v-text-field>
              </div>
              <div>
                <v-autocomplete
                  :items="companies"
                  item-text="name"
                  item-value="id"
                  flat
                  label="OWNER COMPANY"
                  :loading="loading_company"
                  :rules="companyRules"
                  v-model="form.company"
                  :search-input.sync="search_company"
                  clearable
                  persistent-hint
                  allow-overflow
                  @change="companySelected"
                />
              </div>
              <div>
                <v-autocomplete
                  :items="scrutinizers"
                  item-text="text"
                  item-value="id"
                  flat
                  label="SCRUTINIZER"
                  :loading="loading_scrutinizer"
                  :rules="scrutinizerRules"
                  v-model="form.scrutinizer"
                  :search-input.sync="search_scrutinizer"
                  clearable
                  persistent-hint
                  allow-overflow
                  :disabled="!form.company"
                />
              </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="success"
              flat="flat"
              @click="() => {
                $router.push(`/evoting/entity/${$route.params.id}`);
                dialogs.update = false;
              }"
            >
              Don't Update
            </v-btn>

            <v-btn
              color="error"
              flat="flat"
              :disabled="!valid"
              @click="updateEntity"
            >
              Update
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-container v-if="error">
      <div>
        <v-alert
          :value="error"
          type="error"
        >
          {{ error.graphQLErrors.length > 0 ? error.graphQLErrors[0].message : error.message }}
        </v-alert>
      </div>

      <v-flex sm12 md12 lg12>
        <v-card class="con--view-card" style="min-height:150px;">
          <h2 style="text-align: center;">
            {{ error.graphQLErrors.length > 0 ? error.graphQLErrors[0].data.message : error.message }}
          </h2>

          <div style="text-align: center;">
            <v-btn color="primary" to="/evoting/entity">Go back</v-btn>
          </div>
        </v-card>
      </v-flex>
    </v-container>


    <v-container grid-list-md v-else>
      <v-layout row wrap>
        <v-flex sm12 md12 lg12>
          <v-card class="deal--view-card">
            <p class="deal--view-title">BASIC</p>
            <v-spacer/>
            <div class="deal--view-grid-address">
              <div>
                <p class="deal--view-detail-title">ENTITY ID#</p>
                <p class="deal--view-detail-subtitle">{{entity.id}}</p>
              </div>
              <div>
                <p class="deal--view-detail-title">ENTITY NAME</p>
                <p class="deal--view-detail-subtitle">{{entity.name}}</p>
              </div>
              <div>
                <p class="deal--view-detail-title">COMPANY</p>
                <p class="deal--view-detail-subtitle">
                  <router-link :to="`/company/${entity.company.id}`" style="text-transform: capitalize;">{{ entity.company.name || entity.company.id }}</router-link>
                </p>
              </div>
              <div>
                <p class="deal--view-detail-title">SCRUTINIZER</p>
                <p class="deal--view-detail-subtitle">
                  <router-link :to="`/user-accounts/${entity.scrutinizer.id}`">{{entity.scrutinizer.name}} {{ entity.scrutinizer.email ? `(${entity.scrutinizer.email})` : ''}}</router-link>
                </p>
              </div>
              <div>
                <v-btn color="error" @click="moveTo(`/evoting/entity/${entity.id}?delete=1`)">DELETE</v-btn>
              </div>
              <div>
                <v-btn color="info" @click="moveTo(`/evoting/entity/${entity.id}?update=1`)">UPDATE</v-btn>
              </div>
            </div>
          </v-card>
        </v-flex>
        <v-flex sm12 md12 lg12>
          <v-card class="deal--view-card" style="min-height: 500px; max-height: 500px; overflow-y: scroll;">
            <p class="deal--view-title">EVENTS</p>
            <div v-if="loading_events">
              <h2 style="text-align: center; font-size: 40px;">Loading The Events.</h2>
            </div>
            <div v-if="!loading_events && events.length < 1">
              <h2 style="text-align: center; font-size: 40px;">No Events were found.</h2>
            </div>
            <v-list style="background: inherit;" v-if="!loading_events && events.length > 0">
              <v-list-tile
                v-for="(event, idx) in events"
                :key="event.id"
                avatar
                class="elevation-2"
                style="margin-bottom: 10px;"
              >
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ idx + 1 }}.
                    <router-link :to="`/evoting/event/${event.id}`">
                      {{ event.name }}
                    </router-link>
                  </v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <div>
                    STATUS: {{ getEventStatus(event) }}
                  </div>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>
<script>
import { coreClient } from "../../apollo.js";
import gql from "graphql-tag";
import dfns from "date-fns";

export default {
  data() {
    return {
      entity: {
        id: "",
        name: "",
        company: {
          id: "",
          name: ""
        },
        scrutinizer: {
          id: "",
          name: ""
        }
      },
      snackbar: {
        color: "",
        text: "",
        show: false
      },
      error: "",
      dialogs: {
        update: false,
        delete: false,
        loading: false,
        hasLoaded: false
      },
      valid: false,
      form: {
        name: "",
        company: "",
        scrutinizer: ""
      },
      companyRules: [v => !!v || "The owner company is required."],
      scrutinizerRules: [v => !!v || "The Scrutinizer is required."],
      nameRules: [
        v => !!v || "The name is required.",
        v => v.length > 2 || "The name must be longer than 2 characters."
      ],
      search_company: null,
      search_scrutinizer: null,
      loading_company: null,
      loading_scrutinizer: null,
      loading_events: true,
      scrutinizers: [],
      companies: [],
      events: []
    };
  },
  methods: {
    companySelected() {},
    moveTo(uri) {
      this.$router.push(uri);
      this.$router.go();
    },
    async getEntity(id) {
      this.dialogs.loading = true;
      try {
        const { data } = await coreClient.query({
          query: gql`
            query Entity($id: String!) {
              Entity(id: $id) {
                id
                name
                company {
                  ... on Company {
                    id
                    name
                  }
                  ... on CompanyId {
                    id
                  }
                }
                scrutinizer {
                  ... on User {
                    id
                    name
                    email
                  }
                  ... on UserId {
                    id
                  }
                }
                createdAt
              }
            }
          `,
          variables: {
            id
          },
          fetchPolicy: "no-cache"
        });

        this.entity = data.Entity;
        this.dialogs.hasLoaded = true;
      } catch (e) {
        this.error = e;
      }

      this.dialogs.loading = false;
    },
    async updateEntity() {
      let variables = {};
      let copy = {
        ...this.entity,
        company: this.entity.company.id,
        scrutinizer: this.entity.scrutinizer.id
      };
      Object.keys(this.form).forEach(field => {
        if (copy[field] !== this.form[field]) {
          variables[field] = this.form[field];
        }
      });
      variables["id"] = this.entity["id"];

      try {
        const { data } = await coreClient.mutate({
          mutation: gql`
            mutation updateEntity(
              $id: String!
              $name: String
              $company: String
              $scrutinizer: String
            ) {
              updateEntity(
                id: $id
                name: $name
                company: $company
                scrutinizer: $scrutinizer
              ) {
                id
                name
                company {
                  ... on Company {
                    id
                    name
                  }
                  ... on CompanyId {
                    id
                  }
                }
                scrutinizer {
                  ... on User {
                    id
                    name
                    email
                  }
                  ... on UserId {
                    id
                  }
                }
                createdAt
              }
            }
          `,
          variables
        });

        this.entity = data.updateEntity;
      } catch (e) {
        this.error = e;
      }
      this.dialogs.update = false;
    },
    async deleteEntity() {},
    async getCompanies(variables = {}) {
      try {
        const { data } = await coreClient.query({
          query: gql`
            query Companies($name: String, $limit: Int) {
              Companies(name: $name, limit: $limit) {
                docs {
                  id
                  name
                  logo
                  address
                  phone
                }
              }
            }
          `,
          variables: { ...variables, limit: 20 }
        });

        this.companies = data.Companies.docs;
      } catch (e) {
        this.error = e;
      }
    },
    async getScrutinizers(variables = {}) {
      try {
        const { data } = await coreClient.query({
          query: gql`
            query Users($name: String, $company: String!, $limit: Int) {
              Users(name: $name, limit: $limit, company: $company) {
                docs {
                  id
                  name
                  email
                }
              }
            }
          `,
          variables: { ...variables, limit: 20, company: this.form.company }
        });

        this.scrutinizers = data.Users.docs.map(doc => {
          doc.text = `${doc.name} (${doc.email})`;
          return doc;
        });
      } catch (e) {
        this.error = e;
      }
    },
    async getEvents() {
      this.loading_events = true;
      try {
        const { data } = await coreClient.query({
          query: gql`
            query Events($entity: String!) {
              Events(entity: $entity) {
                docs {
                  id
                  name
                  startDate
                  endDate
                }
              }
            }
          `,
          variables: {
            entity: this.entity.id
          }
        });

        this.events = data.Events.docs;
      } catch (e) {
        // ignore.
      }
      this.loading_events = false;
    },
    getEventStatus(event) {
      return dfns.isPast(new Date(event.endDate))
        ? "Ended"
        : dfns.isPast(event.startDate)
          ? "On Going"
          : "Hasn't Started";
    }
  },
  async mounted() {
    await this.getEntity(this.$route.params.id);
    await this.getEvents();
    const { query } = this.$route;

    if (query.update && query.delete) {
      // IGNORE
      return;
    }

    if (query.update) {
      await this.getCompanies();
      await this.getScrutinizers();
      this.dialogs.update = true;
      return;
    }

    if (query.delete) {
      this.dialogs.delete = true;
      return;
    }

    return;
  },
  watch: {
    error(error) {
      this.snackbar = {
        text:
          error.graphQLErrors.length > 0
            ? error.graphQLErrors[0].data.message
            : error.message,
        show: true,
        color: "error"
      };
    },
    entity(val) {
      this.form = {
        ...val,
        company: val.company.id,
        scrutinizer: val.scrutinizer.id
      };
    },
    async search_company(v) {
      if (!v) {
        this.form.company = "";
        await this.getCompanies();
        return;
      }

      this.loading_company = true;
      v && v !== this.form.company && (await this.getCompanies({ name: v }));
      this.loading_company = false;
    },
    async search_scrutinizer(v) {
      if (!v) {
        this.form.scrutinizer = "";
        await this.getScrutinizers();
        return;
      }

      if (!this.form.scrutinizer) {
        this.loading_scrutinizer = true;
        v &&
          v !== this.form.scrutinizer &&
          (await this.getScrutinizers({ name: v }));
        this.loading_scrutinizer = false;
      }
    }
  }
};
</script>
<style lang="stylus" scoped>
@import '../../assets/stylus/Entity_view.styl';
</style>
